import defaultState from "./state";

const filtroBusquedaPQReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "FILTRO_BUSQUEDA":
      return Object.assign({}, state, defaultState);

    case "CARGAR_PAQUETES": {
      return Object.assign({}, state, {
        loading: false,
        paquetes: action.paquetes,
      });
    }

    case "CARGAR_PAGINACION": {
      return Object.assign({}, state, {
        pageSize: action.paginacion[0].pageSize,
        totalPage: action.paginacion[0].totalPage,
      });
    }

    case "CARGAR_TIPOS_ATENCION": {
      return Object.assign({}, state, {
        tiposAtencion: action.tiposAtencion,
        filtros: {
          tipoAtencion: "0",
          tipoAtencion2: "0",
          tipoAtencion3: [],
          vigencia: "S",
          //inicioVigenciaPaquete: new Date(Date.now()),
        },
      });
    }

    case "CARGAR_NUEVA_PRESTACION": {
      return Object.assign({}, state, {
        modalNuevaPrestacion: action.modalNuevaPrestacion,
      });
    }

    case "CAMBIAR_TIPO_ATENCION2": {
      //console.log(action.tipoAtencion2.Descripcion);
      let filtros = [];
      if (state.filtros.tipoAtencion3 === "0") {
        filtros = Object.assign({}, state.filtros, {
          tipoAtencion3: { Valor: state.filtros.tipoAtencion, Descripcion: action.tipoAtencion2 },
          tipoAtencion2: action.tipoAtencion2,
        });
      } else {
        filtros = Object.assign({}, state.filtros, {
          tipoAtencion3: action.tipoAtencion3 /*+ { Valor: state.filtros.tipoAtencion, Descripcion: action.tipoAtencion2 }*/,
          tipoAtencion2: action.tipoAtencion2,
        });
      }
      return Object.assign({}, state, {
        filtros,
      });
    }

    case "CAMBIAR_TIPO_ATENCION3": {
      //console.log(action.tipoAtencion2.Descripcion);
      const filtros = Object.assign({}, state.filtros, {
        tipoAtencion3: action.tipoAtencion3
      });
      return Object.assign({}, state, {
        filtros,
      });
    }

    case "CAMBIAR_TIPO_ATENCION": {
      const filtros = Object.assign({}, state.filtros, {
        tipoAtencion: action.tipoAtencion,
        tipoAtencion2: "0",
      });
      return Object.assign({}, state, {
        filtros,
      });
    }

    case "LOADING": {
      return Object.assign({}, state, {
        loading: action.loading,
      });
    }

    case "LOADINGEXCEL": {
      return Object.assign({}, state, {
        loadingExcel: action.loadingExcel
      })
    }

    case "CARGAR_SOLICITUDES": {
      let idSolicitudAux = null;
      let openModal = false;

      if (action.solicitudes.length > 0) {
        idSolicitudAux = action.solicitudes[0].IdSolicitud;
        openModal = true;
      }
      return Object.assign({}, state, {
        solicitudes: action.solicitudes,
        idSolicitud: idSolicitudAux,
        modalCargarBorrador: openModal,
      });
    }

    case "OPEN_CARGAR_BORRADOR": {
      return Object.assign({}, state, {
        modalCargarBorrador: action.modalAction,
      });
    }

    case "CARGAR_DETALLE_SOLICITUD_FIL": {
      let mostrarmodalAux = false;
      if (action.prestacionesSolicitud.length > 0) {
        mostrarmodalAux = true;
      }

      return Object.assign({}, state, {
        prestacionesSolicitud: action.prestacionesSolicitud,
        modalCargarBorrador: mostrarmodalAux,
        idSolicitud: action.idSolicitud,
      });
    }

    case "ACT_PAQUETE_SET_SOLICITUD_EN_CURSO": {
      let aux = [];
      if (action.result != null) {
        action.result.forEach(element => {
          aux.push(element.PAQU_CODIGO);
        });
      }
      return Object.assign({}, state, {
        solicitudEnCurso: action.solicitudEnCurso,
        paquetesEnCurso: aux,
      });
    }

    case "CAMBIAR_INICIO_VIGENCIA": {
      const filtros = Object.assign({}, state.filtros, {
        inicioVigenciaPaquete: action.inicioVigenciaPaquete,
      });
      return Object.assign({}, state, {
        filtros,
      });
    }

    case "CAMBIAR_VIGENCIA": {
      const filtros = Object.assign({}, state.filtros, {
        vigencia: action.vigencia,
      });
      return Object.assign({}, state, {
        filtros,
      });
    }

    case "CAMBIAR_CODIGO_INTERVENCION": {
      const filtros = Object.assign({}, state.filtros, {
        codIntervencion: action.codIntervencion,
      });
      return Object.assign({}, state, {
        filtros,
      });
    }

    case "CAMBIAR_CODIGO_PAQUETE_PRESTADOR": {
      const filtros = Object.assign({}, state.filtros, {
        codPaquetePres: action.codPaquetePres,
      });
      return Object.assign({}, state, {
        filtros,
      });
    }

    case "CAMBIAR_GLOSA_PAQUETE": {
      const filtros = Object.assign({}, state.filtros, {
        glosa: action.glosa,
      });
      return Object.assign({}, state, {
        filtros,
      });
    }

    default:
      return state;
  }
};

export default filtroBusquedaPQReducer;



// WEBPACK FOOTER //
// ./src/components/Paquetes/FiltroBusquedaPQ/reducer.js